module.exports = __webpack_public_path__ + "img/64.09db671e.jpg";